export default __webpack_public_path__ + "static/media/accept-invite.4db6415b.svg";